import React from "react";

export const BankIdContext = React.createContext<any>(null);
